import React from 'react';

import PropTypes from 'prop-types';

import {
    Form,
    FormInput,
    Validate,
} from 'wanderu-component-form';
import Helmet from 'wanderu-component-helmet';
import { Button } from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import { SnowplowService } from 'wanderu-service-analytics';

import config from '../../../config/baseApp.locales';

import styles from './ResetPasswordForm.scss';

function ResetPasswordForm(props) {
    const {
        hasError,
        email,
        onResetPassword,
        loading,
        success,
        t,
    } = props;

    const title = t('account-section-title_meta', {
        pageSection: t('reset-password_page-section'),
    });

    function onSuccess(formData) {
        SnowplowService.fireStructuredEvent({
            action: 'submit',
            category: 'user_accounts',
            label: 'reset_password_form',
        });

        return onResetPassword(formData.email);
    }

    return (
        <>
            <Helmet
                supportedLocales={config.supportedLocales}
                title={title}
                noReferrer
            />
            <Form
                defaultValues={{ email: email }}
                hasError={hasError}
                inputClass={styles.input}
                inputWithMessageClass={styles.inputWithMessage}
                onSuccess={onSuccess}
            >
                <Validate
                    key="email"
                    type="email"
                    required
                >
                    <FormInput
                        placeholder={t('email')}
                        type="email"
                    />
                </Validate>
                <Button
                    className={styles.button}
                    loading={loading}
                    success={success}
                    type="submit"
                >
                    {t('send-email-button')}
                </Button>
            </Form>
        </>
    );
}

ResetPasswordForm.propTypes = {
    email: PropTypes.string,
    hasError: PropTypes.bool,
    loading: PropTypes.bool,
    onResetPassword: PropTypes.func.isRequired,
    success: PropTypes.bool,
    t: PropTypes.func.isRequired,
};

ResetPasswordForm.defaultProps = {
    email: '',
    hasError: false,
    loading: false,
    success: false,
};

export { ResetPasswordForm };
export default localize(ResetPasswordForm, config.namespace);
